// © Microsoft Corporation. All rights reserved.

import { TelemetryObjectBase } from "@msnews/telemetry-contracts";
import { getPageContentType } from "@msnews/social-utils";

export interface ContentSocialBarTelemetryObjects {
    container: TelemetryObjectBase;
    reactionBreakdown: TelemetryObjectBase;
}

export const contentSocialBarTelemetryContracts = {
    container: {
        name: "ContentSocialBar",
        type: getPageContentType()
    },
    reactionBreakdown: {
        type: getPageContentType()
    }
};